import resetReduxAction from '../../../redux/actions/reset'
import { START_WORKOUT_ACTION, START_WORKOUT_DOMAIN, START_WORKOUT_KEY } from '../../constants'

export default function resetStartWorkoutAction () {
  return resetReduxAction({
    type: START_WORKOUT_ACTION.RESET_STATE,
    payload: {
      path: START_WORKOUT_DOMAIN,
      keysToOmit: [
        START_WORKOUT_KEY.IS_AUDIO_TIMER_ENABLED_SETTING,
        START_WORKOUT_KEY.IS_AUDIO_GUIDANCE_ENABLED_SETTING,
        START_WORKOUT_KEY.IS_VIDEO_ENABLED_SETTING,
        START_WORKOUT_KEY.IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING,
        START_WORKOUT_KEY.PREPARATION_TIME_BEFORE_SET
      ]
    }
  })
}
